/* eslint react/prop-types: 0 */
import React from 'react';

function DataTextArea({ value }) {
  return <p style={{ whiteSpace: 'pre-wrap', fontSize: '0.67rem' }}>{value}</p>;
}

export default DataTextArea;
